<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>This book is dedicated to my mom (deceased), dad, husband, my two girls, all my brothers, Ann Marie Steele Daley, Tashna Servis-Morris (my sisters and friends); all my relatives and friends, for all their love. I consider myself blessed beyond measure to have each and every one of you in my life. My greatest desire is that this book brings healing in families. I am grateful that my parents inspired a love for reading in me from a very early age, my dad always bought me literature books and I always had “free time” to read. I am beyond grateful.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?12bfcdcc